import { render } from "./InfoSection.vue?vue&type=template&id=9f58e932"
import script from "./InfoSection.vue?vue&type=script&lang=ts"
export * from "./InfoSection.vue?vue&type=script&lang=ts"

import "./InfoSection.vue?vue&type=style&index=0&id=9f58e932&lang=scss"
script.render = render

export default script